import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Heart, Compass } from 'lucide-react';
import { NeuralBackground } from '../ui';
const problems = [{
  icon: Brain,
  title: 'MINTEA',
  subtitle: 'OBOSEALĂ. CONFUZIE. BLOCAJ MENTAL.',
  text: 'Lucrezi, te implici, dai tot ce ai. Dar în cap e zgomot. Iei o decizie și imediat te îndoiești. Începi multe și termini puține. Simți că ai potențial, dar ceva te ține pe loc și nu înțelegi exact ce anume.'
}, {
  icon: Heart,
  title: 'RELAȚIILE',
  subtitle: 'TENSIUNE. NEÎNȚELEGERI. SINGURĂTATE.',
  text: 'Unele conversații merg ușor. Altele par că vorbești cu peretele, oricât ai încerca. Simți că nu ești înțeles cu adevărat. Sau că, deși ai reușit în plan profesional, în plan personal ceva lipsește și nu știi cum să schimbi asta.'
}, {
  icon: Compass,
  title: 'DIRECȚIA',
  subtitle: 'LIPSĂ SENS. FRICĂ. AMÂNARE.',
  text: 'Știi că ar trebui să faci ceva diferit, dar nu știi de unde să începi. Obiectivele tale sună bine pe hârtie, dar nu te mobilizează. Uneori te întrebi dacă ce faci contează cu adevărat. Și rămâi în același loc, zi după zi.'
}];
export const Problems = () => {
  return <section className="py-24 bg-navy relative overflow-hidden" data-id="element-195">
      <NeuralBackground data-id="element-196" />
      <div className="container mx-auto px-6 relative z-10" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-198">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-199">
            Te regăsești în cel puțin una din aceste situații?
          </h2>
          <div className="w-24 h-px bg-gold mx-auto mt-8" data-id="element-200" />
        </motion.div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-201">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-navy-card border border-gold/30 p-10 relative group hover:border-gold/60 transition-colors duration-300" data-id="element-202">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-203" />
              <prob.icon className="w-10 h-10 text-gold mb-8 stroke-[1.5]" data-id="element-204" />
              <h3 className="font-serif text-2xl font-bold text-white mb-2 uppercase tracking-wide" data-id="element-205">
                {prob.title}
              </h3>
              <p className="font-display text-xs font-bold text-gold mb-6 tracking-widest uppercase" data-id="element-206">
                {prob.subtitle}
              </p>
              <p className="font-sans text-textSub leading-relaxed text-sm md:text-base" data-id="element-207">
                {prob.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};